import { DomeComponent, DomeManipulator, React } from "@lexriver/dome";
import { StringMethods } from "@lexriver/string-methods";
import { Settings } from "../../Settings";
import { IBasket } from "../Basket/IBasket";
import { GlobalBasket } from "../GlobalBasket";
import { GlobalUser } from "../GlobalUser";
import { getTotalAmountToPayByJsonBasketStats, getTotalAmountToPayByJsonBasketStatsInDollar } from "../json-data-types/JsonBasketStats";
import css from './BasketStatsOnBottom.m.scss'
import { Price } from "./Price";
import { BasketStatsCoupons } from "./BasketStatsCoupons";

interface Attrs{

}

export class BasketStatsOnBottom extends DomeComponent<Attrs>{
    render(){
        return <div class={css.total}></div>
    }

    afterRender(){
        this.subscribeToCouponUpdateEvent()
        this.subscribeToBasketUpdateEvent()
        this.scheduleUpdate()
    }

    protected subscribeToBasketUpdateEvent(){
        GlobalBasket.onBasketUpdateEvent.subscribe(async () => {
            //console.log('BasketRow.tsx', 'basketUpdate')
            if(!DomeManipulator.isInDom(this.rootElement)) {
                //console.log('BasketRow.tsx', 'unsubscribe!')
                return {unsubscribe:true}
            }
            this.scheduleUpdate()
        })
    }

    protected subscribeToCouponUpdateEvent(){
        GlobalBasket.onBasketCouponChangeEvent.subscribe(async () => {
            console.log('BasketStatsOnBottom')
            if(!DomeManipulator.isInDom(this.rootElement)){
                return {unsubscribe:true}
            }
            this.scheduleUpdate()
        })
    }


    async updateAsync(){
        // console.log('BasketStats update')
        const basket:IBasket = await GlobalBasket.getCurrentBasketAsync()
        const basketStats = await basket.getStatsAsync({getJsonOrderItems:false})
        // console.log('basketStats=', basketStats)
        const canSeeWholesalePrices = await GlobalUser.checkIfCanSeeWholesalePricesAsync()

        await DomeManipulator.replaceAllChildrenAsync(this.rootElement,
            <>
                {/* <div class={css.totalHeader}>Корзина</div> */}
                <div class={css.grid}>
                {canSeeWholesalePrices
                    ?
                        <>
                            <div class={css.label}>Всего товаров</div>
                            <div class={css.value}><strong>{basketStats.totalQuantity}</strong></div>

                            <div class={css.label}>Сумма оптовая</div>
                            <div class={css.value}>
                                <strong>
                                    {/* {Settings.formatNumberToPrice(basketStats.wholesaleSum)} */}
                                    <Price price={basketStats.wholesaleSum} priceInDollar={basketStats.wholesaleSumDollar} />
                                </strong>
                            </div>

                            <div class={css.label}>Сумма розничная</div>
                            <div class={css.value}>
                                <Price price={basketStats.retailSum} priceInDollar={basketStats.retailSumDollar} />
                            </div>
                        </>
                    :
                    <>
                        <div class={css.label}>Всего товаров</div>
                        <div class={css.value}><strong>{basketStats.totalQuantity}</strong></div>

                        <div class={css.label}>На общую сумму</div>
                        <div class={css.value}><strong><Price price={basketStats.retailSum} priceInDollar={basketStats.retailSumDollar} /></strong></div>
                    </>
                }

                <BasketStatsCoupons basketStats={basketStats} />

                {basketStats.discountAmountByCouponCode && Object.keys(basketStats.discountAmountByCouponCode).length>0 &&
                    <>
                            <div class={css.label}>Итого к оплате</div>
                            <div class={css.value}>
                                <strong>
                                    <Price 
                                        price={getTotalAmountToPayByJsonBasketStats({stats:basketStats, useWholesaleSum:canSeeWholesalePrices})}
                                        priceInDollar={getTotalAmountToPayByJsonBasketStatsInDollar({stats:basketStats, useWholesaleSum:canSeeWholesalePrices})} 
                                    />
                                </strong>
                            </div>
                    </>
                }
                </div>

            </>
        )
    }

    // formatTotalProducts(countOfProducts:number){
    //     return StringMethods.formatPluralNumber({
    //         number: countOfProducts,
    //         settings: {
    //             locale: 'ru',
    //             ifZero:(x)=>null,
    //             ifOne:(x)=><><strong>{x}</strong> товар</>,
    //             ifFew:(x)=><><strong>{x}</strong> товара</>,
    //             ifMany:(x)=><><strong>{x}</strong> товаров</>
    //         }
    //     })
    // }

}